import toast from "react-hot-toast";
import AddProductsFrom from "../../Form/AddProductsFrom";
import "../Modal.css";
import { useState } from "react";
import Swal from "sweetalert2";

const ModalUpdateCompany = ({ isVisible, onClose, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const companyId = "678363fef3dff9528dc37bfa";

  const [formData, setFormData] = useState({
    CompanyName: "",
    CompanyType: "",
    CompanyDes: "",
    websiteUrl: "",
    phone: "",
    address: "",
  });
  const [logo, setLogo] = useState(null); // For storing the selected file
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file input
  //   const handleFileChange = (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       setLogo(file);
  //     }
  //   };

  //   const [profilePicture, setprofilePicture] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setLogo(e.dataTransfer.files[0]);
      e.dataTransfer.clearData(); // Clear data after handling drop
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setLogo(e.target.files[0]);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    const data = new FormData();
    data.append("CompanyName", formData.CompanyName);
    data.append("CompanyType", formData.CompanyType);
    data.append("CompanyDes", formData.CompanyDes);
    data.append("websiteUrl", formData.websiteUrl);
    data.append("phone", formData.phone);
    data.append("address", formData.address);

    if (logo) {
      data.append("profilePicture", logo);
    }

    try {
      const response = await fetch(
        `https://server-gs.vercel.app/event-company-update/${companyId}`,
        {
          method: "PUT",
          body: data,
        }
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          title: "Success!",
          text: "Company profile updated successfully!",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        })
        closeModal(); // Close the modal
        setFormData({
          CompanyName: "",
          CompanyType: "",
          CompanyDes: "",
          websiteUrl: "",
          phone: "",
          address: "",
        });
        setLogo(null);
      } else {
        throw new Error(result.error || "Failed to update company details");
      }
    } catch (error) {
      setErrorMessage(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!isVisible) return null;
  return (
    <div
      className="fixed inset-0  bg-opacity-75 flex justify-center items-center z-50"
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="bg-white rounded-lg shadow-custom-full w-[1000px] mx-5 sm:mx-auto">
        <div className="flex justify-between py-3 px-5 items-center border-b shadow-md bg-blue-500">
          <h1 className="text-white text-xl font-roboto text500">
            Update your company details
          </h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="bg-green p-5 h-[620px] overflow-y-auto shadow-lg ">
          <div className="p-4 ">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="grid grid-cols-2 gap-5">
                <div className="flex flex-col">
                  <label
                    className="font-roboto text-xl text-gray-900"
                    htmlFor="CompanyName"
                  >
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="CompanyName"
                    name="CompanyName"
                    value={formData.CompanyName}
                    onChange={handleChange}
                    className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                  />
                </div>

                <div className="flex flex-col">
                  <label
                    className="font-roboto text-xl text-gray-900"
                    htmlFor="CompanyType"
                  >
                    Company Type
                  </label>
                  <input
                    type="text"
                    id="CompanyType"
                    name="CompanyType"
                    value={formData.CompanyType}
                    onChange={handleChange}
                    className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                  />
                </div>

                <div className="flex flex-col">
                  <label
                    className="font-roboto text-xl text-gray-900"
                    htmlFor="CompanyDes"
                  >
                    Description
                  </label>
                  <textarea
                    id="CompanyDes"
                    name="CompanyDes"
                    value={formData.CompanyDes}
                    onChange={handleChange}
                    className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                  />
                </div>

                <div className="flex flex-col">
                  <label
                    className="font-roboto text-xl text-gray-900"
                    htmlFor="websiteUrl"
                  >
                    Website URL
                  </label>
                  <input
                    type="url"
                    id="websiteUrl"
                    name="websiteUrl"
                    value={formData.websiteUrl}
                    onChange={handleChange}
                    className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                  />
                </div>

                <div className="flex flex-col">
                  <label
                    className="font-roboto text-xl text-gray-900"
                    htmlFor="phone"
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                  />
                </div>

                <div className="flex flex-col ">
                  <label
                    className="font-roboto text-xl text-gray-900"
                    htmlFor="address"
                  >
                    Address
                  </label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                  />
                </div>
              </div>

              <div className="flex flex-col">
                <label
                  className="font-roboto text-xl text-gray-900"
                  htmlFor="profilePicture"
                >
                  Company Logo
                </label>
                {/* <input
                  type="file"
                  id="profilePicture"
                  name="profilePicture"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="border p-2 mt-2 rounded-md font-roboto text-lg h-10 border-gray-500"
                /> */}
                <div
                  className={`px-6 py-16 border-2 rounded-lg mt-2 text-center transition-colors duration-200 ${
                    isDragging
                      ? "border-blue-500 bg-blue-100"
                      : "border-gray-300"
                  }`}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  {logo ? (
                    <div className="flex flex-col items-center">
                      <img
                        src={URL.createObjectURL(logo)}
                        alt="Selected"
                        className="w-32 h-32 object-cover mb-4"
                      />
                    </div>
                  ) : (
                    <p className="text-gray-500">
                      Drag & Drop a file here or click to select
                    </p>
                  )}
                  <input
                    type="file"
                    id="profilePicture"
                    className="hidden"
                    onChange={handleFileChange}
                    name="profilePicture"
                  />
                  <label
                    htmlFor="profilePicture"
                    className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                  >
                    Browse File
                  </label>
                </div>
              </div>

              <button
                type="submit"
                className="bg-blue-500 mt-5 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Company"}
              </button>
            </form>
          </div>
        </div>
        <div className="flex  mx-5"></div>
      </div>
    </div>
  );
};

export default ModalUpdateCompany;
